// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor_wmybA {
  display: grid;
  grid-template-columns: 40% 40% 1fr;
  column-gap: var(--size-padSmall);
  row-gap: var(--size-padSmall);
}

.add_FQm9L {
  flex-basis: 40px;
}

.closed_YCgza { 
  grid-column: span 2;
  white-space: nowrap !important;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-operating-hours/lib/RangesEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kCAAkC;EAClC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC","sourcesContent":[".editor {\n  display: grid;\n  grid-template-columns: 40% 40% 1fr;\n  column-gap: var(--size-padSmall);\n  row-gap: var(--size-padSmall);\n}\n\n.add {\n  flex-basis: 40px;\n}\n\n.closed { \n  grid-column: span 2;\n  white-space: nowrap !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `editor_wmybA`,
	"add": `add_FQm9L`,
	"closed": `closed_YCgza`
};
export default ___CSS_LOADER_EXPORT___;
